import { render, staticRenderFns } from "./MaskingReasonsSetup.vue?vue&type=template&id=6f90c609&scoped=true"
import script from "./MaskingReasonsSetup.vue?vue&type=script&lang=ts"
export * from "./MaskingReasonsSetup.vue?vue&type=script&lang=ts"
import style0 from "./MaskingReasonsSetup.vue?vue&type=style&index=0&id=6f90c609&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f90c609",
  null
  
)

export default component.exports